(()=>{
  const init=(scope=document)=>{
    scope.querySelectorAll('[data-bv-tabs]').forEach(root=>{
      if(root.dataset.bvTabsReady)return;
      root.dataset.bvTabsReady='true';
      const tabs=[...root.querySelectorAll('[data-bv-tab]')];
      const activate=(tab,focus=false)=>{
        tabs.forEach(item=>{const selected=item===tab;item.setAttribute('aria-selected',String(selected));item.tabIndex=selected?0:-1;});
        root.querySelectorAll('[data-bv-panel]').forEach(panel=>panel.hidden=panel.dataset.bvPanel!==tab.dataset.bvTab);
        if(focus)tab.focus();
      };
      tabs.forEach((tab,i)=>{
        tab.addEventListener('click',()=>activate(tab));
        tab.addEventListener('keydown',event=>{
          let index=i;
          if(event.key==='ArrowRight')index=(i+1)%tabs.length;
          else if(event.key==='ArrowLeft')index=(i+tabs.length-1)%tabs.length;
          else if(event.key==='Home')index=0;
          else if(event.key==='End')index=tabs.length-1;
          else return;
          event.preventDefault();activate(tabs[index],true);
        });
      });
    });
    scope.querySelectorAll('[data-bv-carousel]').forEach(control=>{
      if(control.dataset.bvCarouselReady)return;
      const rail=control.previousElementSibling;
      if(!rail?.classList.contains('bv-rail'))return;
      control.dataset.bvCarouselReady='true';
      const slides=[...rail.children];const dots=control.querySelector('[data-bv-dots]');
      if(dots)slides.forEach((slide,i)=>{const dot=document.createElement('button');dot.type='button';dot.setAttribute('aria-label',`Go to review ${i+1}`);dot.addEventListener('click',()=>rail.scrollTo({left:slide.offsetLeft-rail.offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));dots.append(dot);});
      const update=()=>{
        const max=rail.scrollWidth-rail.clientWidth;const progress=max>0?Math.min(1,rail.scrollLeft/max):0;
        const track=control.querySelector('.bv-track span');if(track)track.style.transform=`translateX(${progress*400}%)`;
        const index=slides.reduce((best,slide,i)=>Math.abs(slide.offsetLeft-rail.offsetLeft-rail.scrollLeft)<Math.abs(slides[best].offsetLeft-rail.offsetLeft-rail.scrollLeft)?i:best,0);
        dots?.querySelectorAll('button').forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));
        control.querySelector('[data-bv-prev]').disabled=rail.scrollLeft<=2;
        control.querySelector('[data-bv-next]').disabled=rail.scrollLeft>=max-2;
      };
      const move=direction=>{const slide=slides[0];const gap=parseFloat(getComputedStyle(rail).gap)||16;rail.scrollBy({left:direction*((slide?.getBoundingClientRect().width||rail.clientWidth)+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
      control.querySelector('[data-bv-prev]').addEventListener('click',()=>move(-1));
      control.querySelector('[data-bv-next]').addEventListener('click',()=>move(1));
      rail.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(rail);update();
    });
    scope.querySelectorAll('[data-bv-signup]').forEach(button=>{
      if(button.dataset.bvSignupReady)return;button.dataset.bvSignupReady='true';
      button.addEventListener('click',()=>{window._klOnsite=window._klOnsite||[];window._klOnsite.push(['openForm',button.dataset.bvSignup]);});
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();

